var map = {
	"./demos/basic/index.ts": 10668,
	"./demos/directory/index.ts": 51221,
	"./demos/drag/index.ts": 52100,
	"./demos/files/index.ts": 57552,
	"./demos/gallery/index.ts": 24762,
	"./demos/manually/index.ts": 96636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44234;